import { useSelector } from 'react-redux';
import { Rules } from './rules.types';
import { getCampaignsFilterRules, getCampaignsFilterRulesCount } from './rules.state';

export const useCampaignFilterRules = () => {
    const rules : Rules = useSelector(getCampaignsFilterRules);
    const rulesCount: number = useSelector(getCampaignsFilterRulesCount);

    return {
        rules,
        rulesCount,
    };
};
